import { PlatformRole } from '../types/onboarding';

export interface PlatformRoleOption {
  value: PlatformRole;
  label: string;
  scope: string;
  description: string;
}

export const PLATFORM_ROLE_OPTIONS: PlatformRoleOption[] = [
  {
    value: 'developer',
    label: 'Developer',
    scope: 'Project',
    description:
      'Work on assigned projects in this organization. Can edit their own contact details.',
  },
  {
    value: 'maintainer',
    label: 'Maintainer',
    scope: 'Organization',
    description:
      'Invite users, update member roles and contact info, and manage projects in this organization.',
  },
  {
    value: 'admin',
    label: 'Admin',
    scope: 'Global',
    description:
      'Full access across all organizations: onboard projects and users, manage any account.',
  },
];

export const ORG_MEMBERSHIP_ROLE_OPTIONS = PLATFORM_ROLE_OPTIONS.filter(
  (role) => role.value !== 'admin'
);
